import { render } from "./AdminTranslationFormFields.vue?vue&type=template&id=c1682610"
import script from "./AdminTranslationFormFields.vue?vue&type=script&lang=js"
export * from "./AdminTranslationFormFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__